import { render, staticRenderFns } from "./color-display.component.vue?vue&type=template&id=323a17b3&"
import script from "./color-display.component.vue?vue&type=script&lang=ts&"
export * from "./color-display.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports